<template>
  <div class="navItemDetails">
    <template v-if="selected">
      <div>
        <nav-records-user
          v-for="person in people"
          :key="person.id"
          :target-id="person.id"
          :type="'justif'"
          :name="person.first_name + ' ' + person.last_name.toUpperCase()"
          :subtitle="(person.type === 'Guarantor' ? $t('records.nav.garantSubtitle') : $t('records.nav.tenant') + ' ' + $t('records.nav.number') + person.order)"
          :bubble="(person.type === 'Guarantor' ? $t('records.nav.garantBubble') : $t('records.nav.tenant').substring(0, 1) + person.order)"
          :notification="personDocuments(person.id)"
          :valid="personDocuments(person.id) === 0"
          :invalid="personDocuments(person.id) > 0"
        />
      </div>
    </template>
  </div>
</template>

<script>
import NavRecordsInterface from './NavRecordsInterface'
import NavRecordsUser from './NavRecordsUser'
import { mapState } from 'vuex'

export default {
  name: "NavRecordsJustifDetails",
  components: {
    NavRecordsUser
  },
  extends: NavRecordsInterface,
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      currentRecordTenants: state => state.recordsPeople.currentRecordTenants,
      currentRecordGuarantors: state => state.recordsPeople.currentRecordGuarantors,
      currentRecordTenantsDocuments: state => state.recordsDocuments.currentRecordTenantsDocuments,
      currentRecordGuarantorsDocuments: state => state.recordsDocuments.currentRecordGuarantorsDocuments
    }),
    people() {
      let guarantorsCount = 1
      let tenantsCount = 1

      return [
        ...this.currentRecordTenants.map(item => {
          item.order = tenantsCount
          tenantsCount++

          return item
        }),
        ...this.currentRecordGuarantors.map(item => {
          item.order = guarantorsCount
          guarantorsCount++

          return item
        })
      ]
    },
    personDocuments() {
      return id => {
        const guarantors = this.currentRecordGuarantors.length > 0 ? this.currentRecordGuarantorsDocuments : {}
        const documents = {
          ...this.currentRecordTenantsDocuments,
          ...guarantors
        }
        return documents ? documents[id].filter(document => document.required && !document.document).length : 0
      }
    }
  }
}
</script>
